import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { AllocationViewTruckLeftActionState } from './allocation-view-truck-left-action.state';
import {
  AllocationViewTruckLeftAction,
  AllocationViewTruckLeftActionSetInitialState,
} from './allocation-view-truck-left-action.actions';

@Injectable({ providedIn: 'root' })
export class AllocationViewTruckLeftActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewTruckLeftActionState.getLoaded);

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  execute(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewTruckLeftAction({
            identifier,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewTruckLeftActionSetInitialState());
  }
}
